<div class="header-wrapper" *ngIf="!hideHeader" [ngClass]="{'mobile': mobile}">
  <div class="header-main" >
    <div class="container header-pos" *ngIf="showMenu">
      <ng-container *ngIf="!mobile; else mobileTemplate">
        <div class="left-part">
          <ng-container *ngIf="!mobile">
            <a routerLink="/home" class="header-logo">
              <img src="./assets/img/logo-app-header.svg" alt="logo" />
            </a>
          </ng-container>
          <button
            *ngIf="showMenu"
            class="btn-primary-light catalog-btn only-icon"
            [ngClass]="{ 'catalog-btn-mob': mobile, 'hide-btn': searchService.lgSearchForDesktop && !mobile }"
            [disabled]="disableMenuClick"
            (click)="goToFilteredCatalogByPlType()">
            <i class="icon icon-all_catalog"></i>
            <span class="btn-text">{{ 'catalog' | translate }}</span>
          </button>
          <button
            *ngIf="!mobile && allowActivateOutlet"
            class="btn-primary-light add-category only-icon"
            [ngClass]="{ 'hide-btn': searchService.lgSearchForDesktop && !mobile }"
            (click)="addNewCategoryClick()"
            [disabled]="disableMenuClick"
          >
            <i class="icon icon-add_catalog"></i>
            <span class="btn-text">{{ 'new_category' | translate }}</span>
          </button>
          <button
            *ngIf="isHasPromo"
            class="btn-secondary-light promo-btn only-icon"
            [ngClass]="{ 'promo-btn-mob': mobile}"
            [disabled]="disableMenuClick"
            (click)="goToPromo()"
          >
            <i class="icon icon-percentage"></i>
            <span class="btn-text">{{ 'promo' | translate }}</span>
          </button>
        </div>
        <app-search
          #searchFormInput
          *ngIf="!mobile"
          (searchInput)="searchInput($event)"
        ></app-search>
        <div class="right-part">
          <button [disabled]="disableMenuClick" class="btn-icon-light menu-item"
                  (click)="openNotificationsClick()">
            <i class="icon icon-notification" ></i>
            <div *ngIf="(userNotificationService.newNotificationsCounter | async) as counter" class="notification-count">
              {{ counter }}
            </div>
          </button>
          <button [disabled]="disableMenuClick" class="btn-icon-light menu-item"
                  (click)="goToFilteredCatalogByPlType(priorityListType.favorites)">
            <i class="icon icon-likes" ></i>
          </button>
          <button [disabled]="disableMenuClick" class="btn-icon-light menu-item" routerLink="/orderhistory">
            <i class="icon icon-orders" ></i>
          </button>
          <div class="btn-icon-light menu-item">
            <app-menu
              *ngIf="!mobile && showMenu"
              #appMenu
              [mobile]="mobile"
              [disableMenuClick]="disableMenuClick"
            ></app-menu>
          </div>
          <button class="btn-primary-light cart-btn only-icon" (click)="toCart()" *ngIf="isCart">
            <ng-container *ngIf="totalCartSum !== null; else loading">
              <div class="icon-container">
                <span class="cart-badge" *ngIf="quantityProducts > 0">{{ quantityProducts}}</span>
                <i class="icon-cart icon-add_to_cart" [ngClass]="{ 'disabled-icon-cart': disableMenuClick }"></i>
              </div>
              <span class="btn-text">{{'cart-btn' | translate}}</span>
            </ng-container>
            <ng-template #loading>
              {{ 'loading' | translate }}
            </ng-template>
          </button>
        </div>
      </ng-container>
      <ng-template #mobileTemplate>
        <div class="mobile-top">
          <app-menu
            *ngIf="showMenu"
            [mobile]="mobile"
            [disableMenuClick]="disableMenuClick"
            [isHasPromo]="isHasPromo"
          ></app-menu>
          <img *ngIf="showMenu" routerLink="home" class="logo cursor-pointer" src="./assets/img/logo-app-header.svg" alt="logo" />
          <button *ngIf="showMenu" class="btn-cart" (click)="toCart()">
                <span class="cart-badge" *ngIf="quantityProducts > 0">{{ quantityProducts}}</span>
                <i class="icon icon-add_to_cart" [ngClass]="{ 'disabled-icon-cart': disableMenuClick }"></i>
          </button>
        </div>
          <app-search
            [ngClass]="{'hide': hideSearch, 'show': !hideSearch}"
            class="mobile-search"
            #searchFormInput
            (searchInput)="searchInput($event)"
          ></app-search>
      </ng-template>
    </div>
    <div class="container header-mob" *ngIf="!showMenu && mobile">
        <div class="title-page">
          <i *ngIf="showArrowBack" class="icon icon-arrow_left"
             (click)="toBack()">
          </i>
          <div class="title-text">{{ titlePage | translate }}</div>
        </div>
        <i class="icon icon-close" (click)="toBack()"></i>
    </div>
  </div>
  <div class="header-second"
       *ngIf="!hideSubHeader"
       [@fadeInOut]="hideSearch ? 'hidden' : 'visible'"
       [@.disabled]="!mobile">
    <div class="container header-second-pos">
      <app-sub-header [isCart]="isCart" [mobile]="mobile" [disableChangeUser]="disableChangeUser"></app-sub-header>
    </div>
  </div>
</div>
